import { useNavigate } from 'react-router';

interface BackButtonProps {
  /** Texto visible. Por defecto «Volver atrás»: cambiarlo acá lo cambia en todo el sitio. */
  label?: string;
  className?: string;
}

/**
 * El botón de «volver» que usa cualquier pantalla que lo necesite —
 * confirmación de error, ficha de detalle, formulario. Único lugar del
 * sitio que decide su icono y su texto (`rules/marca.md`): si mañana cambia
 * uno de los dos, es esta línea, no una búsqueda por el código.
 *
 * Usa el historial del navegador (`navigate(-1)`), no una ruta fija: quien
 * lo pulsa vuelve a donde efectivamente estaba, sin importar desde dónde
 * entró a la pantalla actual.
 */
export function BackButton({ label = 'Volver atrás', className = 'btn btn-outline-secondary' }: BackButtonProps) {
  const navigate = useNavigate();
  return (
    <button type="button" className={className} onClick={() => navigate(-1)}>
      <i className="bi bi-arrow-left" aria-hidden="true" /> {label}
    </button>
  );
}
